// extracted by mini-css-extract-plugin
export default {"customersListContainer":"styles_customersListContainer__vEyWW","customersList":"styles_customersList__wV-Vp","customerName":"styles_customerName__r8VSz"};